@if (docOrSoftware) {
  @if (productListService.seperateDocDetails$|async; as facetData) {
    @if (facetTabIndex==7) {
      @if (facetData?.facets) {
        <section class="inner"
          [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
          (click)="block($event)">
          <div class="list-header">
            <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
            <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
              <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
            </button>
          </div>
          @for (facet of facetData?.facets; track facet) {
            <app-facet-kb #facetRef [facet]="facet" [facetTabName]="facetTabIndex"
              [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
          attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
        }
      </section>
    }
  }
}
@if (productListService.seperateSoftDetails$|async; as facetData) {
  @if (facetTabIndex==8) {
    @if (facetData?.facets) {
      <section class="inner"
        [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
        (click)="block($event)">
        <div class="list-header">
          <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
          <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
            <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        </div>
        @for (facet of facetData?.facets; track facet) {
          <app-facet-kb #facetRef [facet]="facet" [facetTabName]="facetTabIndex"
            [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
          attr.aria-label="{{
         'productFacetNavigation.ariaLabelItemsAvailable'
           | cxTranslate
             : {
                 name: facet.name,
                 count: facet?.values?.length
               }
       }}"></app-facet-kb>
      }
    </section>
  }
}
}
@if (productListService.SteeringProdDetails$|async; as facetData) {
  @if (facetTabIndex==9) {
    @if (facetData?.facets) {
      <section class="inner"
        [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
        (click)="block($event)">
        <div class="list-header">
          <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
          <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
            <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        </div>
        @for (facet of facetData?.facets; track facet) {
          <app-facet-kb #facetRef [facet]="facet" [facetTabName]="facetTabIndex"
            [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
          attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
      }
    </section>
  }
}
}
@if (productListService.FormulaProdDetails$|async; as facetData) {
  @if (facetTabIndex==10) {
    @if (facetData?.facets) {
      <section class="inner"
        [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
        (click)="block($event)">
        <div class="list-header">
          <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
          <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
            <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        </div>
        @for (facet of facetData?.facets; track facet) {
          <app-facet-kb #facetRef [facet]="facet" [facetTabName]="facetTabIndex"
            [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
          attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
      }
    </section>
  }
}
}
} @else {
  @if (!isCategeoryPage) {
    @if (productListService.countDetails$|async; as facetData) {
      @if (facetTabIndex==0) {
        @if (facetData?.productModel?.facets) {
          <section class="inner"
            [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
            (click)="block($event)">
            <div class="list-header">
              <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
              <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
                <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
              </button>
            </div>
            @for (facet of facetData?.productModel?.facets; track facet) {
              <app-facet-kb #facetRef [facet]="facet"
                [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
            [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
            'productFacetNavigation.ariaLabelItemsAvailable'
              | cxTranslate
                : {
                    name: facet.name,
                    count: facet?.values?.length
                  }
          }}"></app-facet-kb>
          }
        </section>
      }
    }
    @if (facetTabIndex==1) {
      @if (facetData?.crossRefModel?.facets) {
        <section class="inner"
          [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
          (click)="block($event)">
          <div class="list-header">
            <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
            <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
              <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
            </button>
          </div>
          <!--
          Here we'd like to introduce configurable facet components,
          either by using specific configuration or generic sproutlets
          -->
          @for (facet of facetData?.crossRefModel?.facets; track facet) {
            <app-facet-kb #facetRef [facet]="facet"
              [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
            [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
        }
      </section>
    }
  }
  @if (facetTabIndex==2) {
    @if (facetData?.docModel?.facets) {
      <section class="inner"
        [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
        (click)="block($event)">
        <div class="list-header">
          <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
          <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
            <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        </div>
        <!--
        Here we'd like to introduce configurable facet components,
        either by using specific configuration or generic sproutlets
        -->
        @for (facet of facetData?.docModel?.facets; track facet) {
          <app-facet-kb #facetRef [facet]="facet"
            [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
            [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
      }
    </section>
  }
}
@if (facetTabIndex==3) {
  @if (facetData?.softwareModel?.facets) {
    <section class="inner"
      [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
      (click)="block($event)">
      <div class="list-header">
        <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
        <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
          <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
        </button>
      </div>
      <!--
      Here we'd like to introduce configurable facet components,
      either by using specific configuration or generic sproutlets
      -->
      @for (facet of facetData?.softwareModel?.facets; track facet) {
        <app-facet-kb #facetRef [facet]="facet"
          [facetTabName]="facetTabIndex" [class.expanded]="isExpanded(facet) | async"
            [class.collapsed]="isCollapsed(facet) | async" role="group" attr.aria-label="{{
             'productFacetNavigation.ariaLabelItemsAvailable'
               | cxTranslate
                 : {
                     name: facet.name,
                     count: facet?.values?.length
                   }
           }}"></app-facet-kb>
    }
  </section>
}
}
}
} @else {
  @if (categoryFacetData$| async; as model) {
    @if (model?.['subCategories']) {
      @if (model?.['subCategories'].length!=0) {
        <div class="category-section">
          <h2 class="categoryTittle">{{'common.text_subcategories_label'|cxTranslate}}</h2>
          <ul class="categoryList">
            @for (product of model?.['subCategories']; track product) {
              <li>
                @if ((product.url).indexOf('http')>-1) {
                  <!--   <a [href]="productUrl$ | async" target="_blank">{{product.name}}</a> -->
                  <a [href]="productUrlsMap[product.url] | async" target="_blank">{{product.name}}</a>
                }
                @if ((product.url).indexOf('http')<=-1) {
                  <a [routerLink]="product.url">{{product.name}}</a>
                }
              </li>
            }
          </ul>
        </div>
      }
    } @else {
      @if (model?.facets) {
        <section class="inner"
          [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate" [tabindex]="-1"
          (click)="block($event)">
          <div class="list-header">
            <h4>{{'common.search_nav_selectRefinements_title' | cxTranslate}}</h4>
            <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate" (click)="close()">
              <cx-icon aria-hidden="true" [type]="iconTypes.CLOSE"></cx-icon>
            </button>
          </div>
          <!--
          Here we'd like to introduce configurable facet components,
          either by using specific configuration or generic sproutlets
          -->
          @for (facet of model.facets; track facet) {
            <app-facet-kb #facetRef [facet]="facet" [facetTabName]="6"
              [class.expanded]="isExpanded(facet) | async" [class.collapsed]="isCollapsed(facet) | async" role="group"
            attr.aria-label="{{
               'productFacetNavigation.ariaLabelItemsAvailable'
                 | cxTranslate
                   : {
                       name: facet.name,
                       count: facet?.values?.length
                     }
             }}"></app-facet-kb>
        }
      </section>
    }
  }
}
}
}

